import { Component, OnInit, ComponentFactoryResolver, ViewChild, Input, ViewEncapsulation } from "@angular/core";
import { PluginService } from "../../../services/plugin.service";
import { XsAppConfigService } from "../../../../common/services/xs-app-config.service";
import { MatDialog } from "@angular/material";
import { PlusdCommonService } from "../../../../plusd/services/plusd-common.service";
import { XsMessageBoxComponent } from "../../../../common/widgets/xs-message-box/xs-message-box.component";
import { CoreCommonService } from "../../../services/core-common.service";
import { CookieService } from 'ngx-cookie-service';
import { XsPerfilComponent } from "../xs-perfil/xs-perfil.component";
import { XsBienvenidoComponent } from '../xs-bienvenido/xs-bienvenido.component';
import { JwtService } from '../../../services/jwt.service';
import { JwtHelperInit } from 'src/app/common/helpers/JwtHelperInit';
import { UsuarioService } from 'src/app/plusd/services/usuario.service';
// import { LocalStorageService } from 'ngx-localstorage';

export interface SSOLogin {
  tokenSesion: string;
  idUsuario: string;
  usuarioWindows: string;
  nombreCompleto: string;
  opciones: string;
  perfil: string;
  subsector: string;
}

@Component({
  selector: "app-plugin-xs-explorer",
  templateUrl: "./xs-explorer.component.html",
  styleUrls: ["./xs-explorer.component.css"],
  encapsulation: ViewEncapsulation.None
})
export class PluginXsExplorerComponent implements OnInit {
  // @Input()

  ssoLogin: SSOLogin = { tokenSesion: "", idUsuario: "", usuarioWindows: "", nombreCompleto: "", opciones: null, perfil: null, subsector: "" };
  plusdSesionToken: string;
  moduloAbierto: boolean = false;
  plugInsEnEjecucion: any[] = [];
  submodulos = [];
  modulos = [];
  estadoini = 1;
  nuevossubmod = [];
  pluginsMostrar = [];
  panelOpenState: boolean = false;
  plugins = [];
  tabSeleccionado = 0;
  pluginWidth: string = "400px";

  rucSeleccionado = "3"
  listaRuc = [];
  listaRucFake = [
    {
      "ruc": "1",
      "idAdministrado": "A1",
      "razonSocial": "RAZ A1 EIRL"
    },
    {
      "ruc": "2",
      "idAdministrado": "A2",
      "razonSocial": "RAZ A2 EIRL"
    },
    {
      "ruc": "3",
      "idAdministrado": "A3",
      "razonSocial": "RAZ A3 Empresa Individual de Responsabilidad Empresa Individual de Responsabilidad Limitada Limitada EIRL"
    }
  ]
  mensaje : string = "";
  // seguridad = {
  //   idEmpresa: null,
  //   clave: null,
  //   mostrarLogin: true,
  //   tokenId: null,
  //   idUsuario: null,
  //   codigoUsuario: null,
  //   nombreCompleto: null,
  //   mostrarCambiarClave: false,
  //   parametrosCambioClave: {}
  // };

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    public pluginService: PluginService,
    public xsAppConfigService: XsAppConfigService,
    public dialog: MatDialog,
    public plusdCommonService: PlusdCommonService,
    public coreCommonService: CoreCommonService,
    private cookieService: CookieService,
    public bievenido: XsBienvenidoComponent,
    public usuarioService: UsuarioService,
    public jwtService: JwtService,
    public jwtHelperInit: JwtHelperInit,
    // public localStorageService: LocalStorageService,
  ) { }

  ngOnInit() {
    //this.loadRucs();
    //this.jwtHelperInit.myJwtRequest(false);
    this.mensaje  =""+localStorage.getItem("nombresso")+ " "+localStorage.getItem("mensaje");
    if (this.xsAppConfigService.APLICACION_AMBIENTE == 'localhost-nologin') {
    // if (this.xsAppConfigService.APLICACION_AMBIENTE == 'desarrollo') {
      this.xsAppConfigService.APLICACION_ID_SESION = "0";
      this.ssoLogin = {
        tokenSesion: 'expertsystems',
        idUsuario: '41518',
        usuarioWindows: '26705060', //RUC PRUEBA PARA MINERIA 20100177421   //electricidad 20502597061 //RUC HIDRO 20602213782  //MIna 20103030791
        nombreCompleto: 'XS Developer',
        opciones: null,
        perfil: null,
        subsector: this.cookieService.get('subsector') //FIO 04102019
      }

      this.cookieService.set('usuarioRuc', "20441747072"); //solo prueba
      this.cookieService.set('idUsuario', "29078"); //solo prueba
     // this.obtenerPlugIns(this.ssoLogin);
      return;
    }

    let resSso = JSON.parse(localStorage.getItem("xsSso"));

    if (resSso) {
      
    } else {
      console.error("DEBERIA DE CERRARME");
    }
  }

  loadRucs(){
    this.listaRuc = JSON.parse(localStorage.getItem("listRuc"));
    this.rucSeleccionado = localStorage.getItem("rucSelected");
  }

  verifivarCasilla(){
    this.pluginService.existeCasilla({ruc: this.rucSeleccionado}).then(res =>{
      if (res.data.casillas > 0){

      }
    });
  }

  formatearNombre(nombreCompleto) {

    var MAX_LONGITUD_NOMBRE = 22;

    var apellidoPaterno, apellidoMaterno, primerNombre, segundoNombre;

    nombreCompleto = nombreCompleto.replace('DE LA ', 'DE.LA.');

    if (nombreCompleto.length < MAX_LONGITUD_NOMBRE) {

      var nombreArray = nombreCompleto.split(' ');

      apellidoPaterno = (nombreArray.length >= 1 ? nombreArray[0] : "");
      apellidoMaterno = (nombreArray.length >= 2 ? nombreArray[1] : "");
      primerNombre = (nombreArray.length >= 3 ? nombreArray[2] : "");
      segundoNombre = (nombreArray.length >= 4 ? nombreArray[3] : "");

      nombreCompleto = primerNombre + ' ' + segundoNombre + ' ' + apellidoPaterno + ' ' + apellidoMaterno;
      nombreCompleto = nombreCompleto.replace('.', ' ');
      return nombreCompleto
    }
    else {

      var nombreArray = nombreCompleto.split(' ');
      apellidoPaterno = (nombreArray.length >= 1 ? nombreArray[0] : "");
      apellidoMaterno = (nombreArray.length >= 2 ? nombreArray[1] : "");
      primerNombre = (nombreArray.length >= 3 ? nombreArray[2] : "");

      if ((apellidoPaterno.length + 1) + (apellidoMaterno.length + 1) + primerNombre.length > MAX_LONGITUD_NOMBRE) {
        apellidoMaterno = apellidoMaterno.substring(0, 1) + ".";
      }

      nombreCompleto = primerNombre + ' ' + apellidoPaterno + ' ' + apellidoMaterno;
      nombreCompleto = nombreCompleto.replace('.', ' ');
      return nombreCompleto;
    }


  }

  obtenerPlugIns(ssoLogin) {

    if (this.xsAppConfigService.APLICACION_AMBIENTE == 'localhost-nologin') {
      ssoLogin["opciones"] = [
        // { eNroOrden: 1 },
        { eNroOrden: 11 },
        { eNroOrden: 12 },
        { eNroOrden: 0 },
        { eNroOrden: 1 },
        { eNroOrden: 2 },
        { eNroOrden: 3 },
        // { eNroOrden: 4 },
        { eNroOrden: 5 },
        { eNroOrden: 6 },
        { eNroOrden: 7 },
        // { eNroOrden: 8 },
      ];

      //SOLO PARA PRUEBA CON PERFILES (DEV)---habilitar solo un perfil
      // ssoLogin["perfil"] = [
      //   {PK_eIdPerfil: 323}, //ADMINISTRADO
      //   // {PK_eIdPerfil: 365}, //ADMINISTRADOR
      //   // {PK_eIdPerfil: 224}, //SUPERVISOR
      //  // {PK_eIdPerfil: 364}  //GERENCIA
      // ];
      // this.permisosPerfil(ssoLogin.perfil);

      this.crearEstructuraModuloSubModulo(ssoLogin);
      // this.onClickModulo(this.modulos[0]);
    }

    if (this.xsAppConfigService.APLICACION_AMBIENTE != 'localhost-nologin') {
      let param = {
        // idUsuario: "41555",
        idUsuario: this.cookieService.get("idUsuario"),
        idAplicacion: "223"
      }
      // const param = { idUsuario: ssoLogin.idUsuario, idAplicacion: this.coreCommonService.ID_APLICATION };
      this.pluginService.ListarPorIdUsuario2(param).then(res => {
        ssoLogin["opciones"] = JSON.parse(res.data.opciones);
        ssoLogin["perfil"] = JSON.parse(res.data.perfil);
        this.permisosPerfil(ssoLogin.perfil)
        // this.onClickModulo(this.modulos[0]);
        this.crearEstructuraModuloSubModulo(ssoLogin);
      });

    }

    // WCG Selecciona el primer plugin.
    // Es importante el timeout.
    // setTimeout(() => {
    //   this.onClickModulo(this.modulos[0]);
    // }, 200);

  }

  crearEstructuraModuloSubModulo(ssoLogin) {
    var res = this.procesarSSOLogin2(ssoLogin);
    this.modulos = res.data.sistema.modulos;
    let usuario = res.data.usuario.usuarioWindows;
    // this.xsAppConfigService.APLICACION_USUARIO_WINDOWS = res.data.usuario.usuarioWindows;
    // Inicio 02-03-20
    if (usuario.length == 12) {
      usuario = usuario.substring(0, 11);
    }
    if (usuario.length == 9) {
      usuario = usuario.substring(0, 8);
    }
    this.xsAppConfigService.APLICACION_USUARIO_WINDOWS = usuario;
    // Fin 02-03-20
    this.xsAppConfigService.ID_SUBSECTOR = ssoLogin.subsector;
    this.xsAppConfigService.ID_USUARIO = ssoLogin.idUsuario;
    for (var z = 0; z < this.modulos.length; z++) {
      this.submodulos = this.modulos[z].submodulos;
      //WCG 30102017: Aquie llena la  variable que almacena el total de plugins existente
      for (var i = 0; i < this.modulos.length; i++) {
        for (var j = 0; j < this.modulos[i].submodulos.length; j++) {
          this.modulos[i].submodulos[j].plugInsVisibles = this.modulos[i].submodulos[j].plugIns.filter(function (
            plugIn
          ) {
            return plugIn.visible === true;
          });
          for (var k = 0; k < this.modulos[i].submodulos[j].plugIns.length; k++) {
            var nombreImagen = this.modulos[i].submodulos[j].plugIns[k].imagen;
            this.modulos[i].submodulos[j].plugIns[k].imagen = this.obtenerImagen(
              this.modulos[i].submodulos[j].plugIns[k].id
            );
            this.plugins.push(this.modulos[i].submodulos[j].plugIns[k]);
          }
        }
      }
    }

  }

  procesarSSOLogin2(ssoLogin) {
    var submodulos = this.obtenerSubmodulodExSys();
    console.log("submodulos: ", submodulos);
    // console.log("estas en el subsector "+ssoLogin.subsector);
    var opciones = this.ssoLogin.opciones;
    console.log("opciones: ", opciones);

    var allPlugings = [];

    for (var j = 0; j < opciones.length; j++) {
      var p = this.obtenerPlugInExSys(opciones[j]['eNroOrden']);
      var encontro = p.subsector.indexOf(this.cookieService.get('subsector'), 0);
      if (p && encontro >= 0) allPlugings.push(p);
    }

    for (var i = 0; i < submodulos.length; i++) {
      var pluginsPorModulo = allPlugings.filter(function (o) {
        return o.id_modulo === submodulos[i].id;
      });

      //Ordena plugins
      pluginsPorModulo.sort(function (a, b) {
        if (a.orden > b.orden) {
          return 1;
        }
        if (a.orden < b.orden) {
          return -1;
        }
        return 0;
      });

      submodulos[i].plugIns = pluginsPorModulo;
    }

    console.log("submodulos + plugins: ", submodulos);

    //Ordena submodulos
    submodulos.sort(function (a, b) {
      if (a.orden > b.orden) {
        return 1;
      }
      if (a.orden < b.orden) {
        return -1;
      }
      return 0;
    });

    submodulos = submodulos.filter(function (s) {
      return s.plugIns.length > 0;
    });

    var respuesta = {
      data: {
        sistema: {
          id: 5,
          nombre: "SSO",
          modulos: [
            {
              id: 182,
              nombre: "ELECTRICIDAD",
              codSubsector: 'SUB00003',
              icono: "keyboard_arrow_up",
              iconoAlt: "keyboard_arrow_down",
              submodulos: submodulos
            },
            {
              id: 183,
              nombre: "HIDROCARBUROS",
              codSubsector: 'SUB00002',
              icono: "keyboard_arrow_up",
              iconoAlt: "keyboard_arrow_down",
              submodulos: submodulos
            },
            {
              id: 184,
              nombre: "MINERÍA",
              codSubsector: 'SUB00001',
              icono: "keyboard_arrow_up",
              iconoAlt: "keyboard_arrow_down",
              submodulos: submodulos
            },
            {
              id: 185,
              nombre: "INDUSTRIA",
              codSubsector: 'SUB00004',
              icono: "keyboard_arrow_up",
              iconoAlt: "keyboard_arrow_down",
              submodulos: submodulos
            },
            {
              id: 186,
              nombre: "PESCA",
              codSubsector: 'SUB00005',
              icono: "keyboard_arrow_up",
              iconoAlt: "keyboard_arrow_down",
              submodulos: submodulos
            },
          ]
        },
        usuario: { id: ssoLogin.idUsuario, nombre: ssoLogin.nombreCompleto, usuarioWindows: ssoLogin.usuarioWindows }
      }
    };

    console.log("SSO PROCESADO: ", respuesta);

    return respuesta;
  }

  // procesarSSOLogin(ssoLogin) {

  //   var submodulos = [];
  //   var opciones = ssoLogin.opciones;
  //   console.log(opciones);

  //   //_submodulos
  //   var _submodulos = opciones.filter(function (o) {
  //     return o.eIdGrupoOpcion === 0;
  //   });

  //   //plugins
  //   for (var i = 0; i < _submodulos.length; i++) {

  //     var _plugins = opciones.filter(function (o) {
  //       return o.eIdGrupoOpcion === _submodulos[i].PK_eIdOpcion;
  //     });

  //     var plugins = [];
  //     var p = null;

  //     for (var j = 0; j < _plugins.length; j++) {
  //       p = this.obtenerPlugInExSys(_plugins[j].eNroOrden);
  //       if (p) plugins.push(p);
  //     }

  //     //Ordena plugins
  //     plugins.sort(function (a, b) {
  //       if (a.orden > b.orden) {
  //         return 1;
  //       }
  //       if (a.orden < b.orden) {
  //         return -1;
  //       }
  //       return 0;
  //     });

  //     submodulos.push({
  //       icono: "settings",
  //       id: _submodulos[i].PK_eIdOpcion,
  //       nombre: _submodulos[i].uNombreOpcion,
  //       plugIns: plugins
  //     });

  //   }

  //   //Ordena submodulos
  //   submodulos.sort(function (a, b) {
  //     if (a.eNroOrden > b.eNroOrden) {
  //       return 1;
  //     }
  //     if (a.eNroOrden < b.eNroOrden) {
  //       return -1;
  //     }
  //     return 0;
  //   });

  //   var respuesta = {
  //     data: {
  //       sistema: {
  //         id: 5,
  //         nombre: "Sistema de Registro, Control y Seguimiento de Multas en el OEFA",
  //         modulos: [
  //           {
  //             id: 182,
  //             nombre: "CONTROL DE MULTAS",
  //             icono: "keyboard_arrow_up",
  //             iconoAlt: "keyboard_arrow_down",
  //             submodulos: submodulos
  //           }
  //         ]
  //       },
  //       usuario: { id: ssoLogin.id, nombre: ssoLogin.nombre, usuarioWindows: ssoLogin.usuario }
  //     }
  //   };

  //   console.log("SSO PROCESADO: ", respuesta);

  //   return respuesta;
  // }

  obtenerSubmodulodExSys() {
    return [
      { id: 1, nombre: "General", icono: "settings", plugIns: [], orden: 1 },
      { id: 2, nombre: "Reportes", icono: "settings", plugIns: [], orden: 2 },
    ];
  }

  tienePermiso(permiso: any, strict: boolean) {
    let p = this.xsAppConfigService.APLICACION_PERFIL;
    // let p = 'US';

    if (this.xsAppConfigService.APLICACION_AMBIENTE == 'localhost-nologin') {
      return true;
    } else {
      let r = false;
      if (permiso) {
        let count = permiso.length;
        for (let i = 0; i < count; i++) {
          console.log(p,permiso[i]);
          if (strict) {
            if (p == permiso[i]) {
              r = true;
            } else {
              r = false;
            }
          } else {
            if (p == permiso[i]) {
              r = true;
            }
          }
        }
        if (r == true) {
          return true;
        } else {
          return false;
        }
      }

    }

    return false;
  }


  obtenerPlugInExSys(id) {
    let permiso =  this.xsAppConfigService.APLICACION_PERFIL;
    switch (id) {
      // case 1:
      //   return {
      //     id: 1,
      //     nombre: "Nombre Ejemplo",
      //     descripcion: "Descripción Ejemplo",
      //     titulo: "",
      //     componente: "ejemplo-listado",
      //     imagen: "assets/images/process.png",
      //     orden: 1,
      //     parametro: '{}',
      //     subsector: '',
      //     visible: true,
      //     tipo_ejecucion: "5",
      //     url_app_externa: 'https://www.google.com.pe/',
      //     id_modulo: 1
      //   };
      //   break;
      case 11:
        return {
          id: 11,
          nombre: "Bandeja de solicitudes",
          descripcion: "Permite la verificación y aprobación de las solicitudes enviadas por el Administrado",
          titulo: "",
          componente: "configuracion-listado",
          imagen: "assets/images/bandeja.png",
          orden: 1,
          parametro: '{}',
          subsector: "",
          visible: this.tienePermiso(["AD","SU"], false),
          tipo_ejecucion: "1",
          url_app_externa: null,
          id_modulo: 1
        };
        break;
      case 0:
        return {
          id: 0,
          nombre: "Casillas Electrónicas",
          descripcion: "Permite el acceso a la Casillas Electrónica del administrado en relación a sus unidades fiscalizables",
          titulo: "",
          componente: "app-casilla-electronica",
          imagen: "assets/images/process.png",
          orden: 3,
          parametro: '{}',
          subsector: '',
          visible: this.tienePermiso(["UP","US"], false),
          tipo_ejecucion: "6",
          url_app_externa: this.coreCommonService.APPLICATION_URL_PUBLICA + "/ingreso-casilla?ruc="+this.rucSeleccionado+"&tipo=3",
          id_modulo: 1
        };
        break;
      case 1:
        return {
          id: 1,
          nombre: "Mesa de Partes Virtual",
          descripcion: "Permite que el administrado pueda acceder a la Mesa de Partes Virtual para presentar y subsanar documentos",
          titulo: "",
          componente: "app-mpv-iframe",
          imagen: "assets/images/folder_64.png",
          orden: 4,
          parametro: '{}',
          subsector: '',
          visible: this.tienePermiso(["UP","US"], false),
          tipo_ejecucion: "1",
          // tipo_ejecucion: "4",
          url_app_externa: "https://sistemas.oefa.gob.pe/mpv",
          id_modulo: 1
        };
        break;
      case 2:
        return {
          id: 2,
          nombre: "Expediente Virtual",
          descripcion: "Permite el acceso a los expedientes de supervisión que el administrado tiene en relación a sus unidades fiscalizables",
          titulo: "",
          componente: "app-expediente-virtual-listado",
          imagen: "assets/images/document_64.png",
          orden: 5,
          parametro: '{}',
          subsector: '',
          visible: this.tienePermiso(["UP","US"], false),
          tipo_ejecucion: "1",
          url_app_externa: null,
          id_modulo: 1
        };
        break;
      case 3:
        return {
          id: 3,
          nombre: "Reporte de Emergencia Ambiental",
          descripcion: "Permite al administrado reportar cualquier emergecia ambiental ocurrida dentro de sus Unidades Fiscalizables",
          titulo: "",
          componente: "app-mensaje",
          imagen: "assets/images/contract_64.png",
          orden: 6,
          parametro: '{}',
          subsector: '',
          visible: this.tienePermiso(["UP","US"], false),
          tipo_ejecucion: "1",
          url_app_externa: null,
          id_modulo: 1
        };
        break;
      case 4:
        return {
          id: 4,
          nombre: "Presentación de Obligaciones",
          descripcion: "",
          titulo: "",
          componente: "app-mensaje",
          imagen: "assets/images/documents_64.png",
          orden: 7,
          parametro: '{}',
          subsector: '',
          visible: false,
          tipo_ejecucion: "1",
          url_app_externa: null,
          id_modulo: 1
        };
        break;
      case 5:
        return {
          id: 5,
          nombre: "Aporte Por Regulación",
          descripcion: "Permite el acceso al sistema APR donde los Administrados obligados, pueden realizar su Declaración mensual.",
          titulo: "",
          componente: "app-mensaje",
          imagen: "assets/images/price_64.png",
          orden: 8,
          parametro: '{}',
          subsector: '',
          visible: this.tienePermiso(["UP","US"], false),
          tipo_ejecucion: "1",
          url_app_externa: null,
          id_modulo: 1
        };
        break;
      case 6:
        return {
          id: 6,
          nombre: "Acceso a la Información",
          descripcion: "",
          titulo: "",
          componente: "app-mensaje",
          imagen: "assets/images/suitcase_64.png",
          orden: 9,
          parametro: '{}',
          subsector: '',
          visible: this.tienePermiso(["UP","US"], false),
          tipo_ejecucion: "1",
          url_app_externa: null,
          id_modulo: 1
        };
        break;
      case 7:
        return {
          id: 7,
          nombre: "Quejas y Reclamos",
          descripcion: "Permite que el administrado pueda presentar cualquier inconformidad o insatisfacción ante la OEFA",
          titulo: "",
          componente: "app-mensaje",
          imagen: "assets/images/claim_64.png",
          orden: 10,
          parametro: '{}',
          subsector: '',
          visible: this.tienePermiso(["UP","US"], false),
          tipo_ejecucion: "1",
          url_app_externa: null,
          id_modulo: 1
        };
        break;
      case 8:
        return {
          id: 8,
          nombre: "Otros",
          descripcion: "",
          titulo: "",
          componente: "app-mensaje",
          imagen: "assets/images/other_64.png",
          orden: 11,
          parametro: '{}',
          subsector: '',
          visible: false,
          tipo_ejecucion: "1",
          url_app_externa: null,
          id_modulo: 1
        };
        break;
      case 12:
        return {
          id: 12,
          nombre: "Administración de Usuarios Secundarios",
          descripcion: "Permite la administración de usuarios adicionales al usuario principal",
          titulo: "",
          componente: "app-usuario-secundario-listado",
          imagen: "assets/images/usuarios_secundarios.png",
          orden: 2,
          parametro: '{}',
          subsector: '',
          visible: this.tienePermiso(["UP"], true),
          tipo_ejecucion: "1",
          url_app_externa: null,
          id_modulo: 1
        };
        break;
    }
  }

  // mostrarLogin(): void {
  //   const dialogRef = this.dialog.open(LoginPluginComponent, {
  //     width: "400px",
  //     panelClass: "xs-login-dlg",
  //     data: { username: "wcastro", name: "William" }
  //   });

  //   dialogRef.afterClosed().subscribe(resultado => {
  //     console.log("The dialog was closed");
  //     this.onAfterCloseLoginView(resultado);
  //   });
  // }

  mostrarMessageBox(titulo, mensaje, onAfterCloseDialog): void {
    const dialogRef = this.dialog.open(XsMessageBoxComponent, {
      width: "400px",
      data: { titulo: titulo, mensaje: mensaje }
    });

    dialogRef.afterClosed().subscribe(resultado => {
      if (onAfterCloseDialog) onAfterCloseDialog();
    });
  }

  abrirCerrarModulos() {
    this.moduloAbierto = !this.moduloAbierto;
  }

  onClickModulo(m) {
    this.submodulos = m ? m.submodulos : null;
    this.tabSeleccionado = 0;
    this.ssoLogin.subsector = m.codSubsector;
    this.obtenerPluginPorSubsector(m);
    this.xsAppConfigService.ID_SUBSECTOR = this.ssoLogin.subsector;
    this.estadoini = 0;
  }


  obtenerPluginPorSubsector(dato) {
    var subsector = this.ssoLogin.subsector;
    var opciones = Object.values(this.ssoLogin.opciones);
    var allPlugings = [];
    for (var j = 0; j < opciones.length; j++) {
      var p = this.obtenerPlugInExSys(opciones[j]['eNroOrden']);
      var encontro = p.subsector.indexOf(subsector);
      if (encontro >= 0) {
        allPlugings.push(p);
      }
    }
    for (var i = 0; i < dato.submodulos.length; i++) {
      var pluginsPorModulo = allPlugings.filter(function (o) {
        return o.id_modulo === dato.submodulos[i].id;
      });
      //Ordena plugins
      pluginsPorModulo.sort(function (a, b) {
        if (a.orden > b.orden) {
          return 1;
        }
        if (a.orden < b.orden) {
          return -1;
        }
        return 0;
      });
      dato.submodulos[i].plugIns = pluginsPorModulo;
    }
    this.nuevossubmod = dato.submodulos;
  }

  onClickSubmodulo(s) {
    console.log('s', s);
    this.nuevossubmod = [s];
    console.log('sub', this.nuevossubmod)
    this.tabSeleccionado = 0;
  }

  obtenerImagen(idPlugin) {
    return this.xsAppConfigService.obtenerImagen(idPlugin);
  }

  onClickPerfil() {
    console.log("ssoLogin", this.ssoLogin);
    let params = {
      idUsuario: this.ssoLogin.idUsuario,
    }
    this.mostrarDlgXsPerfil(params);
  }

  onClickCerrarSesion() {
    var URLactual = window.location;
    let plusdSesionToken = this.cookieService.get('plusdSesionToken');
    this.cookieService.deleteAll();
    localStorage.clear();
/*
    if (this.xsAppConfigService.APLICACION_AMBIENTE == 'localhost-nologin') {
      window.location.href = this.coreCommonService.APPLICATION_APP_HOST;
    } else {
      window.location.href = ""+URLactual;
    }*/

    window.location.href = ""+URLactual;
  }

  onClickCrearPlugIn(p) {
    console.log("Aqui", p);

    //Verifica el tipo de ejecución del plugin
    switch (p.tipo_ejecucion) {
      case "1": //Se refiere que cuando se ejecuta un plugin este se puede ejecutar multiples veces
        //Esta clonando una nueva instancia del plugin
        var nuevaInstancia = Object.assign({}, p);

        //Cuando viene del metodo onCrearPlugInExterno la propiedad parametro ya es un objeto
        if (typeof nuevaInstancia.parametro === "string")
          nuevaInstancia.parametro = JSON.parse(nuevaInstancia.parametro);

        var instanciasEnEjecucion = this.plugInsEnEjecucion.filter(function (plugIn) {
          return plugIn.id === nuevaInstancia.id;
        });

        nuevaInstancia.nroInstancia = instanciasEnEjecucion.length + 1;
        nuevaInstancia.localId = "plugIn" + nuevaInstancia.id + "-" + nuevaInstancia.nroInstancia;

        //WCG 30102017: Se ha agregado la opción de que pase el parametro al hijo
        nuevaInstancia.parametro.plugInPadre = this;
        nuevaInstancia.parametro.plugIn = nuevaInstancia;
        this.plugInsEnEjecucion.push(nuevaInstancia);

        //this.active = nuevaInstancia.localId;

        setTimeout(() => {
          this.tabSeleccionado = this.plugInsEnEjecucion.length + 1; // add "+1" Pablo 16-08-19
        }, 500);

        console.log("this.tabSeleccionado", this.tabSeleccionado);

        break;
      case "2": //En este caso solo puede haber una instancia del plugin
        //TODO
        break;
      case "3": //En este caso se lanza una neva aplicacion en un nuevo TAB del browser
        // var _self = this;
        // sesionApiRequestProvider
        //   .CrearSesion({
        //     jsonData: {
        //       userId: this.seguridad.idUsuario,
        //       idEmpresa: exsysAppConfigProvider.APLICACION_ID_EMPRESA,
        //       idSistema: exsysAppConfigProvider.APLICACION_ID_SISTEMA
        //     }
        //   })
        //   .then(t => {
        //     let url = p.url_app_externa + "&idsesion=" + t.data
        //     console.log("URL: ", url);
        //     window.open(url, "_blank");
        //   });

        break;
      case "4":
        window.open(p.url_app_externa, "_blank");
        break;
      case "5":
        let url = p.url_app_externa + "&tokenApp=" + this.ssoLogin.tokenSesion
        window.open(url, "_blank");
        break;
      case "6":
        this.pluginService.existeCasilla({ruc: this.rucSeleccionado}).then(res =>{
          if (res.data > 0){
            window.open(p.url_app_externa, "_blank");
          }else{
            this.mostrarMessageBox2("ADVERTENCIA","Usted no cuenta con una casilla con el ruc seleccionado");
          }
        });
        break;
      default:
        console.log("ERROR OnClickCrearPlugIn: El tipo de ejecucion no existe");
    }
  }

  onClickCerrarPlugIn(p) {
    var i = 0;
    var siguienteActivo = 0;

    for (i = this.plugInsEnEjecucion.length - 1; i >= 0; i--) {
      if (this.plugInsEnEjecucion[i].localId == p.localId) {
        //siguienteActivo = i - 1 >= 0 ? this.plugInsEnEjecucion[i - 1].localId : "tabAplicaciones";
        siguienteActivo = i + 1; // add "+1" Pablo 16-08-19
        this.plugInsEnEjecucion.splice(i, 1);
        break;
      }
    }
    console.log("siguienteActivo----", siguienteActivo);
    //!Importante: este codigo debe estar dentro de el timeout sino el tab active no responde
    setTimeout(() => {
      this.tabSeleccionado = siguienteActivo;
    }, 500);
  }

  onCrearPlugInExterno(id, parametros) {
    var plugIn = null;

    console.log("this.plugins: ", this.plugins);
    console.log("id: ", id, "parametros: ", parametros);

    //Busca en la lista de plugIns el plugin al que corresponde el id
    plugIn = this.plugins.filter(function (p) {
      return p.id === id;
    });

    //Convierte el parametro de string a objeto
    if (typeof plugIn[0].parametro === "string") plugIn[0].parametro = JSON.parse(plugIn[0].parametro);
    console.log("plugIn", plugIn);

    this.asignarPropiedades(plugIn[0].parametro, parametros);

    //Si el plugin existe, crea la instancia
    this.onClickCrearPlugIn(plugIn[0]);
  }

  asignarPropiedades(object, source) {
    Object.keys(source).forEach(function (key) {
      object[key] = source[key];
    });
  }

  permisosPerfil(permisos) {
    let permiso = "";
    console.log("PERMISOS PERFIL: ", permisos);
    if (permisos!=null){
      for (let i = 0; i < permisos.length; i++) {
        switch (permisos[i].PK_eIdPerfil) {
          case 283:
            permiso = "AD"; break;
          case 284:
            permiso = "SU"; break;
          case 285:
            permiso = "UP"; break;
          case 286:
            permiso = "US"; break;
        }
      }
    }
    this.xsAppConfigService.APLICACION_PERFIL = permiso;
    return this.xsAppConfigService.APLICACION_PERFIL;
  }

  // crearPlugin(tipo){

  //     switch(tipo)
  //     {
  //       case 1:
  //         this.plugInsEnEjecucion.push({nombre: "Plugin1", componente: "plugin1"});
  //         break;
  //       case 2:
  //         this.plugInsEnEjecucion.push({nombre: "Plugin2", componente: "plugin2"});
  //         break;
  //       default:
  //         break;
  //     }

  //     setTimeout(() => {

  //       let componentFactory = this.componentFactoryResolver.resolveComponentFactory(Plugin1Component);
  //       let viewContainerRef = this.pluginHost.viewContainerRef;
  //       let componentRef = viewContainerRef.createComponent(componentFactory);

  //       let instancia: PluginComponent = <PluginComponent>componentRef.instance;
  //       console.log(instancia);
  //       (<PluginComponent>componentRef.instance).data = [];

  //     }, 1000);

  // }

  /*---------------------------------------------------*/
  /*----------------------DIALOGOS---------------------*/
  /*---------------------------------------------------*/

  mostrarDlgXsPerfil(params) {
    const dialogRef = this.dialog.open(XsPerfilComponent, {
      width: "830px",
      height: "130px",
      panelClass: "xs-dlg-base",
      disableClose: true,
      data: params
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  mostrarMessageBox2(titulo, mensaje): void {
    const dialogRef = this.dialog.open(XsMessageBoxComponent, {
      width: "400px",
      data: { titulo: titulo, mensaje: mensaje }
    });

    dialogRef.afterClosed().subscribe(resultado => {
    });
  }

  onSelectRucSeleccionado(event){
    console.log("ev", event);
    // let rucs = [];
    // for (let i = 0; i < this.listaRuc.length; i++) {
    //   rucs.push(this.listaRuc[i].ruc);
    // }
    // let result = rucs.filter(ruc => ruc == event);
    localStorage.setItem("rucSelected", event)
    this.cookieService.set('usuarioRuc', event);
    // console.log("evComplete", result);

  }
}
